export const ENDPOINTS = {
	// ROOT: 'https://5001-harsh3195-acciojobappba-lidp39zbc69.ws-us63.gitpod.io',
	// ROOT: 'http://localhost:5001',
	ROOT: 'https://api.acciojob.com',

	// ROOT: 'https://acciojob-app-backend-2-pro-fohi8.ondigitalocean.app',
	// ROOT: 'https://67d6-45-251-49-53.ngrok.io'
	// ROOT: 'https://acciojob-app-backend-2-pro-fohi8.ondigitalocean.app',
	// ROOT: 'https://5500-beige-meadowlark-x3367ly3.ws-us25.gitpod.io',
};

// ROOT: 'https://intense-river-03432.herokuapp.com'
